import Button from '@blaze-react/button';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useState } from 'react';
import MultipleDeepLink from './MultipleDeepLink';
import { DATA_LAYER_OPTIONS } from '../../constants';
import { buildTransactionId, pushPurchase } from '../../utils/data-layer';
import { extractListingDataLayerData } from '../../utils/transformers';

const EcommerceDeepLinkButton = ({
  brokerDeepLinks,
  hidden,
  contacts,
  disableClicks,
  yachtData
}) => {
  if (typeof window === 'undefined') return null;

  const [isModalOpen, setModalOpen] = useState(false);

  let handleClick;

  const dataLayerPayload = extractListingDataLayerData(yachtData, contacts);

  if (brokerDeepLinks.length <= 1) {
    handleClick = () => {
      const transactionId = buildTransactionId(yachtData.id);
      pushPurchase(dataLayerPayload, DATA_LAYER_OPTIONS.WEBSITE, transactionId);

      window.open(brokerDeepLinks[0].url, '_blank');
    };
  } else {
    handleClick = () => {
      if (disableClicks) return;

      setModalOpen(true);
    };
  }

  const handleClickInsideModal = deepLink => {
    const personalizedPayload = {
      ...dataLayerPayload,
      brokerIds: deepLink.brokerId,
      brokerNames: deepLink.brokerName
    };

    const transactionId = buildTransactionId(yachtData.id);
    pushPurchase(personalizedPayload, DATA_LAYER_OPTIONS.WEBSITE, transactionId);

    window.open(deepLink.url, '_blank');
  };

  return (
    <>
      <Button
        className={classnames(
          'ecommerce__buttons__button  ecommerce__buttons__button--desktop',
          {
            ['ecommerce__buttons__hidden-button']: hidden,
            ['ecommerce__buttons__button--desktop-multi']: brokerDeepLinks.length > 1
          }
        )}
        title="Visit broker's website"
        onClick={handleClick}>
        Visit broker's website
      </Button>

      {isModalOpen && (
        <MultipleDeepLink
          close={() => setModalOpen(false)}
          brokerDeepLinks={brokerDeepLinks}
          handleClick={handleClickInsideModal}
        />
      )}
    </>
  );
};

EcommerceDeepLinkButton.propTypes = {
  brokerDeepLinks: PropTypes.array.isRequired,
  hidden: PropTypes.bool,
  contacts: PropTypes.array.isRequired,
  disableClicks: PropTypes.bool,
  yachtData: PropTypes.object.isRequired
};

EcommerceDeepLinkButton.defaultProps = {
  hidden: false,
  disableClicks: false
};

export default EcommerceDeepLinkButton;
